/**
 * types of  action
 *
 */
export const PROPERTY_GET_PROPERTIES = 'PROPERTY_GET_PROPERTIES'
export const PROPERTY_GET_PROPERTIES_SUCCESS = 'PROPERTY_GET_PROPERTIES_SUCCESS'
export const PROPERTY_GET_PROPERTIES_FAIL = 'PROPERTY_GET_PROPERTIES_FAIL'
export const PROPERTY_GET_SELECTED_PROPERTY = 'PROPERTY_GET_SELECTED_PROPERTY'
export const PROPERTY_CHANGE_FIELD = 'PROPERTY_CHANGE_FIELD'
export const PROPERTY_DELETE_PROPERTY = 'PROPERTY_DELETE_PROPERTY'
export const PROPERTY_DELETE_PROPERTY_SUCCESS = 'PROPERTY_DELETE_PROPERTY_SUCCESS'
export const PROPERTY_DELETE_PROPERTY_FAIL = 'PROPERTY_DELETE_PROPERTY_FAIL'

export const PROPERTY_UPDATE_PROPERTY = 'PROPERTY_UPDATE_PROPERTY'
export const PROPERTY_UPDATE_PROPERTY_SUCCESS = 'PROPERTY_UPDATE_PROPERTY_SUCCESS'
export const PROPERTY_UPDATE_PROPERTY_FAIL = 'PROPERTY_UPDATE_PROPERTY_FAIL'

export const PROPERTY_SEND_FILE = "PROPERTY_SEND_FILE"
export const PROPERTY_SEND_FILE_SUCCESS = "PROPERTY_SEND_FILE_SUCCESS"
export const PROPERTY_SEND_FILE_FAIL = "PROPERTY_SEND_FILE_FAIL"


export const USER_GET_USERS = 'USER_GET_USERS'
export const USER_GET_USERS_SUCCESS = 'USER_GET_USERS_SUCCESS'
export const USER_GET_USERS_FAIL = 'USER_GET_USERS_FAIL'
export const USERS_CHANGE_FIELD = 'USERS_CHANGE_FIELD'
export const USERS_GET_SELECTED_USER = 'USERS_GET_SELECTED_USER'
export const SAVE_FILE = "SAVE_FILE"
export const USERS_UPDATE_USER = "USERS_UPDATE_USER"
export const USERS_UPDATE_USER_SUCCESS = "USERS_UPDATE_USER_SUCCESS"
export const USERS_UPDATE_USER_FAIL = "USERS_UPDATE_USER_FAIL"
export const USERS_DELETE_USER = "USERS_DELETE_USER"
export const USERS_DELETE_USER_SUCCESS = "USERS_DELETE_USER_SUCCESS"
export const USERS_DELETE_USER_FAIL = "USERS_DELETE_USER_FAIL"
export const USERS_SEND_FILE = "USERS_SEND_FILE"
export const USERS_SEND_FILE_SUCCESS = "USERS_SEND_FILE_SUCCESS"
export const USERS_SEND_FILE_FAIL = "USERS_SEND_FILE_FAIL"